@if (liveCalendar()?.clubResting) {
  <div
    role="status"
    class="mb-4 sm:mb-6 rounded-xl sm:rounded-2xl border border-sky-200/90 bg-gradient-to-r from-sky-50/90 via-white to-sky-50/40 p-4 sm:p-5 shadow-xs dark:border-sky-500/30 dark:bg-gradient-to-r dark:from-slate-900 dark:via-slate-900/95 dark:to-sky-950/40 dark:shadow-sm transition-all"
  >
    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div class="flex items-start sm:items-center gap-3.5 min-w-0">
        <div class="w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-400 border border-sky-200/80 dark:border-sky-500/30 flex items-center justify-center shrink-0 shadow-xs">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect width="18" height="18" x="3" y="4" rx="2" />
            <path d="M8 2v4" />
            <path d="M16 2v4" />
            <path d="M3 10h18" />
            <path d="M10 14v4" />
            <path d="M14 14v4" />
          </svg>
        </div>
        <div class="min-w-0 flex-1">
          <div class="flex items-center gap-2 flex-wrap mb-1">
            <span class="text-xs font-bold uppercase tracking-wider text-sky-700 dark:text-sky-400">
              Jornada de descanso
            </span>
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] sm:text-[11px] font-semibold bg-sky-100 text-sky-800 border border-sky-200/80 dark:bg-sky-500/15 dark:text-sky-300 dark:border-sky-500/30">
              Sin partido programado
            </span>
          </div>
          <p class="text-xs sm:text-sm text-slate-600 dark:text-slate-300 leading-relaxed font-normal">
            Descanso en esta jornada: no hay partido ni taquilla. Se mantienen las obligaciones económicas de la jornada.
          </p>
        </div>
      </div>

      <div class="flex items-center gap-2 shrink-0 pt-2 sm:pt-0 border-t border-slate-200/70 dark:border-slate-800 sm:border-t-0 flex-wrap">
        <div class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/90 dark:bg-slate-800/90 border border-slate-200 dark:border-slate-700/70 text-[11px] font-medium text-slate-600 dark:text-slate-300 shadow-2xs">
          <app-icon name="coins" [size]="14" class="text-amber-500 dark:text-amber-400 shrink-0" />
          <span>Sin taquilla</span>
        </div>
        <div class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/90 dark:bg-slate-800/90 border border-slate-200 dark:border-slate-700/70 text-[11px] font-medium text-slate-600 dark:text-slate-300 shadow-2xs">
          <app-icon name="dollar-sign" [size]="14" class="text-emerald-600 dark:text-emerald-400 shrink-0" />
          <span>Obligaciones activas</span>
        </div>
      </div>
    </div>
  </div>
}
@if (isInitialContextLoading()) {
  <div class="py-24 text-center flex flex-col items-center justify-center space-y-4">
    <div class="w-10 h-10 border-3 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
    <div class="text-sm font-bold text-slate-700 dark:text-slate-300">Cargando competición...</div>
    <p class="text-xs text-slate-400 max-w-xs">Sincronizando competición, estadio, próximos partidos y finanzas.</p>
  </div>
} @else {
<div class="space-y-3 sm:space-y-6 pb-16 sm:pb-8">
  <!-- Next match and standings -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-3 sm:gap-6">
    <!-- Next Match Card (Material M3 Card) -->
    <div
      class="lg:col-span-2 bg-white dark:bg-slate-900 rounded-xl sm:rounded-2xl p-3 sm:p-5 shadow-xs dark:shadow-sm flex flex-col justify-between transition-all relative overflow-hidden"
      [class.border]="!isPlayoff()"
      [class.border-slate-200]="!isPlayoff()"
      [class.dark:border-slate-800]="!isPlayoff()"
      [class.border-2]="isPlayoff()"
      [class.border-amber-500/80]="isPlayoff()"
      [class.dark:border-amber-400/80]="isPlayoff()"
      [class.shadow-lg]="isPlayoff()"
      [class.shadow-amber-500/15]="isPlayoff()"
      [class.dark:shadow-amber-500/20]="isPlayoff()"
      [class.ring-1]="isPlayoff()"
      [class.ring-amber-400/40]="isPlayoff()"
    >
      <div>
        @if (isPlayoff()) {
          <!--<div
            data-testid="playoff-banner"
            class="-mx-3 -mt-3 sm:-mx-5 sm:-mt-5 mb-4 px-4 sm:px-5 py-2.5 sm:py-3 bg-gradient-to-r from-amber-600 via-amber-500 to-yellow-500 text-slate-950 font-sans shadow-md flex items-center justify-between gap-3 relative overflow-hidden select-none"
          >
            <div class="absolute inset-0 opacity-10 pointer-events-none bg-[radial-gradient(#000_1px,transparent_1px)] [background-size:12px_12px]"></div>

            <div class="flex items-center gap-2.5 sm:gap-3 min-w-0 relative z-10">
              <div class="w-8 h-8 rounded-lg bg-black/15 backdrop-blur-xs flex items-center justify-center shrink-0 border border-black/10 shadow-2xs">
                <app-icon name="trophy" [size]="18" class="text-slate-950 drop-shadow-xs" />
              </div>
              <div class="min-w-0">
                <div class="flex items-center gap-2 flex-wrap">
                  <span class="text-xs sm:text-sm font-black tracking-wider uppercase drop-shadow-xs">
                    {{ playoffHeading() }}
                  </span>
                  @if (playoffCycleNumber()) {
                    <span class="text-[10px] font-extrabold uppercase px-1.5 py-0.5 rounded bg-black/15 text-slate-950 border border-black/10">
                      Ciclo {{ playoffCycleNumber() }}
                    </span>
                  }
                </div>
                <p class="text-[11px] font-medium text-slate-900/90 truncate hidden sm:block">
                  {{ playoffSubtext() }}
                </p>
              </div>
            </div>

            <div class="flex items-center gap-2 shrink-0 relative z-10">
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] sm:text-[11px] font-black uppercase tracking-wider bg-slate-950 text-amber-300 shadow-sm border border-amber-400/30">
                <span class="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
                <span>Eliminatoria</span>
              </span>
            </div>
          </div>-->
        }

          @if (!isMatchdayStarted() && matchdayCountdown()) {
            <div
              data-testid="matchday-countdown"
              class="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-xl px-3 py-2.5 text-white transition-all"
              [class.border]="true"
              [class.border-slate-700]="!isPlayoff()"
              [class.border-amber-500/50]="isPlayoff()"
              [class.bg-gradient-to-r]="true"
              [class.from-slate-900]="true"
              [class.to-slate-800]="!isPlayoff()"
              [class.to-amber-950/80]="isPlayoff()"
            >
              <div>
                <div
                  class="text-[10px] uppercase font-bold tracking-wide flex items-center gap-1.5"
                  [class.text-emerald-300]="!isPlayoff()"
                  [class.text-amber-300]="isPlayoff()"
                >
                  @if (isPlayoff()) {
                    <app-icon name="trophy" [size]="12" class="text-amber-400" />
                    <span>Playoff • Ciclo {{ playoffCycleNumber() }}</span>
                  } @else {
                    <span>Próxima jornada</span>
                  }
                </div>
                <div class="text-[10px] text-slate-400 mt-0.5">Inicio: {{ matchStartsAtFormatted() }}</div>
              </div>
              <div class="flex items-center gap-2 rounded-lg border border-white/10 bg-black/30 px-2.5 py-1.5 shrink-0">
                <app-icon name="clock" [size]="16" class="text-amber-400" />
                <span class="text-sm font-bold font-mono text-amber-300">{{ matchdayCountdown() }}</span>
              </div>
            </div>
          } @else if (matchdayProgress(); as mp) {
            <div data-testid="matchday-progress" class="mb-4 space-y-1 w-full">
              <div class="flex items-center justify-between text-[11px] font-medium text-slate-500 dark:text-slate-400">
                <span>Inicio: <strong class="text-slate-700 dark:text-slate-300">{{ mp.startsAtFormatted }}</strong></span>
                <span title="Tiempo restante de jornada"><strong class="text-emerald-600 dark:text-emerald-400 font-mono">{{ mp.remaining }}</strong></span>
                <span>Cierre: <strong class="text-slate-700 dark:text-slate-300">{{ mp.endsAtFormatted }}</strong></span>
              </div>
              <div class="w-full bg-slate-100 dark:bg-slate-800 rounded-full h-2 overflow-hidden border border-slate-200/60 dark:border-slate-700/60">
                <div
                  class="bg-emerald-600 dark:bg-emerald-500 h-full rounded-full transition-all duration-500"
                  [style.width.%]="mp.progress"
                ></div>
              </div>
            </div>
          }
        <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3 mb-4">
          <div class="flex items-center space-x-2 text-slate-500 dark:text-slate-400 text-xs font-bold uppercase tracking-wider flex-wrap gap-y-1">
            <app-icon name="calendar" [size]="14" class="text-emerald-600 dark:text-emerald-400" />
            <span>{{ game.t('dashboard.season_info', { round: currentMatchdayNumber(), total: totalMatchdays() }) }}</span>            
            @if (isLoadingFixture()) {
              <span class="animate-spin text-xs">⏳</span>
            }
          </div>
          <div class="flex items-center space-x-2">
            <span
              class="text-xs font-semibold px-2 py-0.5 rounded-lg"
              [ngClass]="isHome() ? 'bg-blue-50 text-blue-700 border border-blue-200 dark:bg-blue-950 dark:text-blue-400 dark:border-blue-800/60' : 'bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-950 dark:text-amber-400 dark:border-amber-800/60'"
            >
              {{ isHome() ? game.t('dashboard.home') : game.t('dashboard.away') }}
            </span>
          </div>
        </div>

        @if (fixtureError()) {
          <div class="mb-3 px-3 py-1.5 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 dark:bg-amber-950/30 dark:border-amber-800/40 dark:text-amber-300 text-xs flex items-center justify-between">
            <span class="truncate">{{ fixtureError() }}</span>
            <button (click)="loadNextMatch()" class="underline font-medium text-xs ml-2 shrink-0 cursor-pointer">Reintentar</button>
          </div>
        }

        <div class="grid grid-cols-7 items-start gap-2 sm:gap-4 py-4">
          <!-- Home Club Column -->
          <div class="col-span-3 flex flex-col items-center sm:items-start space-y-3">
            <!-- Club Info Badge & Name -->
            <button
              type="button"
              (click)="game.openClubProfile(homeClubDisplay().id, homeClubDisplay().name, homeClubDisplay().code)"
              class="flex items-center space-x-3 w-full text-left group cursor-pointer focus:outline-none"
              [title]="'Ver ficha de ' + homeClubDisplay().name"
            >
              <div class="w-12 h-14 flex items-center justify-center shrink-0 transition-transform group-hover:scale-105">
                <app-club-shield [club]="homeClubDisplay()" size="lg" />
              </div>
              <div class="min-w-0 flex-1">
                <div class="text-sm font-bold text-slate-900 dark:text-white truncate group-hover:underline group-hover:text-emerald-700 dark:group-hover:text-emerald-400" [title]="homeClubDisplay().name">{{ homeClubDisplay().name }}</div>
                <div class="text-xs text-slate-500 dark:text-slate-400">
                  {{ game.t('dashboard.local_badge') }}
                </div>
              </div>
            </button>

            <!-- Camiseta Blanca con Patrocinador Oficial -->
            <div class="w-full flex justify-center sm:justify-start pt-1">
              <app-club-jersey
                [club]="homeClubDisplay()"
                [shield]="homeClubDisplay().shield"
                [sponsor]="homeClubJerseySponsor()"
                [isUser]="homeClubDisplay().isUser"
                (contractClick)="goToSponsors()"
              />
            </div>
          </div>

          <!-- VS Badge / Result in Center Column -->
          <div class="col-span-1 flex flex-col items-center justify-center pt-2 sm:pt-3 text-center">
            <button
              type="button"
              (click)="openNextMatchDetail()"
              class="group/vs flex flex-col items-center justify-center space-y-1 p-1 rounded-2xl transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-emerald-500/50 hover:scale-105 active:scale-95"
              [title]="matchScore() ? 'Ver detalle y actas del partido (' + matchScore() + ')' : 'Ver detalle del partido, alineaciones y sustituciones'"
            >
              @if (matchScore()) {
                <span
                  class="inline-block px-3 py-1 rounded-full bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900 text-xs sm:text-sm font-bold font-mono shadow-sm group-hover/vs:bg-emerald-600 dark:group-hover/vs:bg-emerald-500 group-hover/vs:text-white transition-colors"
                  [class.ring-2]="isPlayoff()"
                  [class.ring-amber-400]="isPlayoff()"
                >
                  {{ matchScore() }}
                </span>
              } @else if (isPlayoff()) {
                <span class="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-gradient-to-r from-amber-500/15 via-yellow-500/20 to-amber-500/15 text-amber-800 dark:text-amber-300 text-xs sm:text-sm font-black font-mono border border-amber-400/60 dark:border-amber-500/50 shadow-xs ring-2 ring-amber-400/30 group-hover/vs:border-amber-500 group-hover/vs:bg-amber-100 dark:group-hover/vs:bg-amber-950/80 transition-all">
                  <app-icon name="trophy" [size]="12" class="text-amber-500" />
                  <span>VS</span>
                </span>
                <span class="text-[9px] font-black uppercase tracking-wider text-amber-600 dark:text-amber-400">
                  Playoff
                </span>
              } @else {
                <span class="inline-block px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-xs sm:text-sm font-black font-mono border border-slate-200/80 dark:border-slate-700 shadow-2xs group-hover/vs:border-emerald-500 group-hover/vs:bg-emerald-50 dark:group-hover/vs:bg-emerald-950/80 group-hover/vs:text-emerald-600 dark:group-hover/vs:text-emerald-400 transition-all">
                  VS
                </span>
              }

              <span class="inline-flex items-center space-x-0.5 text-[9px] sm:text-[10px] font-semibold text-slate-500 dark:text-slate-400 group-hover/vs:text-emerald-600 dark:group-hover/vs:text-emerald-400 transition-colors">
                <app-icon name="eye" [size]="10" />
                <span>Detalle</span>
              </span>
            </button>
          </div>

          <!-- Away Club Column -->
          <div class="col-span-3 flex flex-col items-center sm:items-end space-y-3">
            <!-- Club Info Badge & Name -->
            <button
              type="button"
              (click)="game.openClubProfile(awayClubDisplay().id, awayClubDisplay().name, awayClubDisplay().code)"
              class="flex items-center justify-end space-x-3 text-right w-full group cursor-pointer focus:outline-none"
              [title]="'Ver ficha de ' + awayClubDisplay().name"
            >
              <div class="min-w-0 flex-1">
                <div class="text-sm font-bold text-slate-900 dark:text-white truncate group-hover:underline group-hover:text-emerald-700 dark:group-hover:text-emerald-400" [title]="awayClubDisplay().name">{{ awayClubDisplay().name }}</div>
                <div class="text-xs text-slate-500 dark:text-slate-400">
                  {{ game.t('dashboard.away_badge') }}
                </div>
              </div>
              <div class="w-12 h-14 flex items-center justify-center shrink-0 transition-transform group-hover:scale-105">
                <app-club-shield [club]="awayClubDisplay()" size="lg" />
              </div>
            </button>

            <!-- Camiseta Blanca con Patrocinador Oficial -->
            <div class="w-full flex justify-center sm:justify-end pt-1">
              <app-club-jersey
                [club]="awayClubDisplay()"
                [shield]="awayClubDisplay().shield"
                variant="away"
                [sponsor]="awayClubJerseySponsor()"
                [isUser]="awayClubDisplay().isUser"
                (contractClick)="goToSponsors()"
              />
            </div>
          </div>
        </div>

        <!-- Stadium Showcase Banner: Image + Name + 1-5 Star Rating -->
        @if (venueStadium()) {
        <div class="mt-3 rounded-xl sm:rounded-2xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-slate-950 shadow-xs relative group transition-all">
          <div class="relative w-full aspect-video overflow-hidden bg-slate-900">
            <img
              [src]="effectiveStadiumImage()"
              [alt]="effectiveStadiumName()"
              referrerpolicy="no-referrer"
              class="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 ease-out"
            />
            <!-- Gradient Overlay for High Contrast & Readability -->
            <div class="absolute inset-0 bg-gradient-to-t from-slate-950/95 via-slate-950/10 to-transparent"></div>

            <!-- Top Left: Venue Type Badge -->
            <div class="absolute top-2.5 left-2.5 sm:top-3 sm:left-3 flex items-center space-x-1.5 flex-wrap gap-1">
              <span
                class="inline-flex items-center space-x-1 px-2.5 py-0.5 sm:py-1 rounded-lg text-[10px] sm:text-xs font-bold uppercase tracking-wider backdrop-blur-md shadow-sm border"
                [ngClass]="isHome()
                  ? 'bg-emerald-950/80 text-emerald-300 border-emerald-500/30'
                  : 'bg-amber-950/80 text-amber-300 border-amber-500/30'"
              >
                <app-icon name="building" [size]="12" [class]="isHome() ? 'text-emerald-400' : 'text-amber-400'" />
                <span>{{ isHome() ? 'Sede del Partido (Tu Estadio)' : 'Sede del Partido (A Domicilio)' }}</span>
              </span>
            </div>

            <!-- Top Right: Shortcut to Stadium Upgrade if Home -->
            @if (isHome()) {
              <div class="absolute top-2.5 right-2.5 sm:top-3 sm:right-3 hidden sm:block">
                <button
                  type="button"
                  (click)="goToStadium()"
                  class="inline-flex items-center space-x-1 px-2.5 py-1 rounded-lg text-xs font-semibold text-white/90 bg-black/50 hover:bg-black/70 backdrop-blur-md border border-white/20 transition-all cursor-pointer shadow-xs active:scale-95"
                  title="Gestionar y ampliar estadio"
                >
                  <span>Mejorar estadio</span>
                  <app-icon name="arrow-up-right" [size]="12" />
                </button>
              </div>
            }

            <!-- Bottom Content: Stadium Name + Capacity + Star Rating (1-5 with half-stars) -->
            <div class="absolute bottom-2.5 left-2.5 right-2.5 sm:bottom-3.5 sm:left-4 sm:right-4 flex flex-col sm:flex-row sm:items-end justify-between gap-2">
              <div class="min-w-0">
                <h4 class="text-base sm:text-lg md:text-xl font-extrabold text-white tracking-tight drop-shadow-md truncate">
                  {{ effectiveStadiumName() }}
                </h4>
                <div class="flex items-center space-x-2 text-xs text-slate-300 mt-0.5">
                  <span class="flex items-center space-x-1 text-slate-200">
                    <app-icon name="users" [size]="12" class="text-emerald-400 shrink-0" />
                    <span class="font-bold">{{ effectiveStadiumCapacity().toLocaleString() }}</span>
                    <span class="text-slate-400 font-normal">aforo</span>
                  </span>
                  <span class="text-slate-500">•</span>
                  <span class="text-slate-300 text-[11px] sm:text-xs font-medium">{{ effectiveStadiumCategory() }}</span>
                </div>
              </div>

              <!-- 1-5 Stars Rating Level with Half-Stars -->
              <div class="flex items-center space-x-2 bg-black/75 backdrop-blur-md px-2.5 sm:px-3 py-1 sm:py-1.5 rounded-xl border border-white/15 shrink-0 self-start sm:self-end shadow-md">
                <div class="flex items-center space-x-0.5 sm:space-x-1" [title]="'Estadio Nivel ' + effectiveStadiumRating().toFixed(1) + ' de 5 estrellas'">
                  @for (star of stadiumStarsArray; track star) {
                    @if (effectiveStadiumRating() >= star) {
                      <app-icon
                        name="star"
                        [size]="14"
                        class="text-amber-400 fill-amber-400 drop-shadow-sm"
                      />
                    } @else if (effectiveStadiumRating() >= star - 0.5) {
                      <app-icon
                        name="star-half"
                        [size]="14"
                        class="text-amber-400 drop-shadow-sm"
                      />
                    } @else {
                      <app-icon
                        name="star"
                        [size]="14"
                        class="text-slate-600 fill-none"
                      />
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        } @else {
          <p class="mt-3 text-sm text-slate-500 dark:text-slate-400" role="status">Datos del estadio no disponibles.</p>
        }        
      </div>

      <!-- Bottom bar of match card -->
      <div class="mt-6 pt-3 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between text-xs">
        <div class="flex items-center space-x-2">
          @if (isLoadingLineup()) {
            <span role="status">{{ game.t('common.loading') }}</span>
          } @else if (!isLineupAvailable()) {
            <span role="status">{{ game.t('dashboard.lineup_unavailable') }}</span>
          } @else if (isLineupComplete()) {
            <span class="flex items-center space-x-1 text-emerald-700 dark:text-emerald-400 font-semibold">
              <app-icon name="check-circle" [size]="14" />
              <span>{{ game.t('dashboard.lineup_ready') }}</span>
            </span>
          } @else {
            <span class="flex items-center space-x-1 text-amber-600 dark:text-amber-400 font-semibold">
              <app-icon name="alert-circle" [size]="14" />
              <span>{{ game.t('dashboard.lineup_incomplete', { current: assignedStartersCount() }) }}</span>
            </span>
          }
        </div>

        <div class="flex items-center space-x-3">
          <button
            (click)="game.setActiveTab('squad')"
            class="text-emerald-600 hover:text-emerald-700 dark:text-emerald-400 dark:hover:text-emerald-300 font-semibold flex items-center space-x-1 cursor-pointer"
          >
            <span>{{ game.t('dashboard.edit_lineup') }}</span>
            <app-icon name="chevron-right" [size]="14" />
          </button>
        </div>
      </div>
    </div>

    <!-- League Standings -->
    <div class="min-w-0 bg-white dark:bg-slate-900 rounded-xl sm:rounded-2xl border border-slate-200 dark:border-slate-800 px-1 sm:px-5 py-2.5 sm:py-5 shadow-xs dark:shadow-sm flex flex-col justify-between transition-colors">
      <div>
        <div class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-2.5 sm:pb-3 mb-2 sm:mb-3 px-1 sm:px-0">
          <div class="flex items-center space-x-2 text-slate-500 dark:text-slate-400 text-xs font-bold uppercase tracking-wider">
            <app-icon name="trophy" [size]="14" class="text-amber-500" />
            <span>{{ game.t('dashboard.standings_title') }}</span>
            @if (isLoadingStandings()) {
              <span class="animate-spin text-xs">⏳</span>
            }
          </div>
        </div>

        <app-competition
          [embedded]="true"
          [showCalendar]="false"
          [standingsInCard]="true"
          [suppliedStandings]="standings()"
          [suppliedStandingsLoading]="isLoadingStandings()"
          [suppliedStandingsError]="standingsError()"
          (standingsRefresh)="loadStandings(undefined, true)"
        />
      </div>
    </div>
  </div>

  <app-competition #calendarComp [embedded]="true" [showStandings]="false" />
</div>
}
